var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var SendIcon = function (_a) {
    var _b = _a.w, w = _b === void 0 ? 21 : _b, _c = _a.h, h = _c === void 0 ? 16 : _c, props = __rest(_a, ["w", "h"]);
    return (_jsx("svg", __assign({ width: w, height: h, viewBox: '0 0 21 16', xmlns: 'http://www.w3.org/2000/svg' }, props, { children: _jsx("path", { d: 'M0.695312 0.0078125L2.03125 0.546875L20.2422 8L0.695312 15.9922L1.02344 14.5859L2.47656 8L1.02344 1.41406L0.695312 0.0078125ZM2.78125 2.49219L3.83594 7.25H14.4297L2.78125 2.49219ZM3.83594 8.75L2.78125 13.5078L14.4297 8.75H3.83594Z', fill: 'currentColor' }) })));
};
